export default {
  button: {
    backgroundColor: 'red'
  },
  View: {
    height: '100%'
  },
  backgroundView: {
    position: 'absolute',
    bottom: '0px',
    backgroundColor: '#00000085',
    width: '100%',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    color: '#fff',
    padding: '2px 0px',
    fontSize: '7px'
  },
  timeView: {
    position: 'absolute',
    right: '4px',
    fontSize: '6px',
    lineHeight: '7px',
    top: '2px',
    fontWeight: '500'
  },
  activeCard: {
    marginRight: '13px',
    position: 'relative',
    border: '1px solid #14D15B',
    borderRadius: '5px'
  },
  card: {
    marginRight: '13px',
    position: 'relative',
    border: '1px solid transparent',
    borderRadius: '5px'
  }
};
